@if (color()) {
    <div class="status-pill" [ngClass]="color()">
        @if (icon()) {
            <app-icon class="icon" [svgIcon]="icon()"></app-icon>
        }
        @if (label()) {
            <div class="label small-text-bold">{{ label() }}</div>
        }
    </div>
}